import { AdacButton } from '@adac-de/component-library';
import React from 'react';
import { clsx } from 'clsx';
import styles from './back-button.module.scss';
import { Icon } from '@components/icons/icons';

type BackButtonProps = {
  onClick: () => void;
  label: string;
  btnClass?: string;
  tabIndex?: number;
};

export const BackButton: React.FC<BackButtonProps> = ({ onClick, label, btnClass, tabIndex }) => (
  <AdacButton
    variant="unstyled"
    className={clsx(btnClass, styles.backBtn)}
    onClick={onClick}
    tabIndex={tabIndex}
    data-testid="backButton"
  >
    <Icon.ArrowLeft /> {label}
  </AdacButton>
);
